export default __webpack_public_path__ + "assets/icon2-fd0d8a7.svg";